import { useState, MouseEvent } from 'react';

export const usePopover = () => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const openPopover = (event: MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
  };
  const closePopover = () => {
    setAnchor(null);
  };
  const togglePopover = (event: MouseEvent<HTMLElement>) => {
    setAnchor(anchor ? null : event.currentTarget);
  };

  const isOpen = Boolean(anchor);

  return {
    openPopover,
    closePopover,
    togglePopover,
    anchor,
    isOpen,
  };
};
